/**
 * Copyright Aquera Inc 2023
 *
 * This source code is licensed under the BSD-3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { css } from 'lit-element';

/**
 * Drawer CSS
 */
export const styles = css`
  :host {
	background-color: var(--nile-alert-color-background-base);
    padding: var(----nile-spacing-1-x);
    position: fixed;
    top: 0px;
    right: 0px;
    width: 424px;
    height: 100vh;
    background: #ffff;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1), 0 4px 11px rgba(0, 0, 0, 0.1);
    transform: translateX(100%);
    z-index: 999;
	position: absolute;
	top: 0;
	right: 0;
	width: 35%;
  }
`;
